<template>

    <section v-bind="$attrs" class="topper topper-short relative bg-white">

        <div class="interior flex flex-wrap items-center relative px-4">
        
            <div class="relative z-30 mx-auto w-full">
                <div class="max-w-4xl mx-auto">
                    <SmoothLoader class="text-container text-center">
                        <span v-if="kicker" class="kicker block font-headline uppercase font-bold text-lg" v-html="kicker" :class="background_image ? 'text-primary-400' : 'text-primary-500'"></span>
                        <h1 :class="headlineClass" class="headline leading-tight w-full font-black font-headline" v-html="headline"></h1>
                        <span class="author font-headline font-bold transition-colors block mt-2" :class="background_image ? 'text-gray-500' : 'text-gray-800'" v-if="post && post.author" v-html="'By ' + post.author"></span>
                        <span class="subhead font-headline font-bold transition-colors block mt-2" :class="background_image ? 'text-primary-400' : 'text-primary-500'" v-if="subhead" v-html="subhead"></span>
                        <a v-if="instagramLink" href="https://www.instagram.com/reel/Cs56uE-qmzg/?igshid=MzRlODBiNWFlZA%3D%3D" target="_blank" class="inline-block text-secondary-500 underline mt-1 transition-colors hover:text-primary-500 focus:text-primary-500">Or click here to see a fun reviews recap video</a>
                    </SmoothLoader>
                </div>
            </div>

            <div class="bouncer absolute w-full left-0 z-40 flex justify-center" :class="{'py-8': !background_image && !subnav}">
                <a @click.prevent="quickCustomEvent('clickedSmoothAnchor', {id: 'content-start'})" href="#content-start" class="bg-white w-10 h-10 rounded-full flex items-center justify-center shadow-xl">
                    <i class="fa-solid fa-arrow-circle-down text-secondary-500 text-2xl transition-colors" aria-hidden="true"></i>
                    <span class="sr-only">Skip to Content</span>
                </a>
            </div>

        </div>

    </section>

    <AnchorId :data="{id: 'content-start'}"></AnchorId>
</template>

<script>

import AnchorId from './Slices/AnchorId.vue';
import HeroLogo from './HeroLogo.vue';
import { quickCustomEvent } from '../helpers.js';
import { computed } from 'vue';

export default {
    
    props: ['data', 'filters', 'post'],

    components: {
        AnchorId,
        HeroLogo
    },

    setup(props) {

        console.log(props);

        let topper_button = computed(() => {
            return props.data.topper_button ?? null;
        });

        const headlineClass = computed(() => {
            let size = (props.data.headline.length >= 30)
                ? 'text-4xl vt:text-5xl'
                : 'text-5xl vt:text-7xl';
            let color = props.data.background_image
                ? 'text-gray-500 text-shadow-1'
                : 'text-primary-700';
            return size + " " + color;
        });

        const kicker = computed(() => {
            if (props.data.options.kicker) {
                return props.data.options.kicker;
            }
            if (props.post?.post_type === 'post') {
                return props.post.date;
            }
            return null;
        });

        const subhead = computed(() => {
            if (props.data.options.subhead) {
                return props.data.options.subhead;
            }
            return null;
        });

        return {
            kicker,
            subhead,
            headlineClass,
            quickCustomEvent,
            ...props.data,
            topper_button
        }
    }

}
</script>